import { apiClient } from '@/libs/axios';
import type { ApiParamsDefault, ApiResponsePagination } from '@/types/api.type';
import { queryOptions } from '@tanstack/react-query';
import type { MentorBalanceHistoryEntry } from '../types/mentor-balance-history.type';

export type GetMentorBalanceHistoryParams = Partial<
  Pick<ApiParamsDefault, 'page' | 'limit'>
> & {
  id_balance: number;
};
export type GetMentorBalanceHistoryResponse =
  ApiResponsePagination<MentorBalanceHistoryEntry>;

export const getMentorBalanceHistory = async (
  params: GetMentorBalanceHistoryParams
): Promise<GetMentorBalanceHistoryResponse> => {
  const { id_balance, ...query } = params;
  const url = `balance/${id_balance}/history`;

  return await apiClient.get(url, { params: query });
};

export const GET_MENTOR_BALANCE_HISTORY_QUERY_KEY = 'mentor-balance-history';
export function getMentorBalanceHistoryQueryOptions(
  params: GetMentorBalanceHistoryParams
) {
  return queryOptions({
    queryKey: [GET_MENTOR_BALANCE_HISTORY_QUERY_KEY, params],
    queryFn: () => getMentorBalanceHistory(params),
  });
}
